import React from 'react';
import Icon from '../common/Icons';
import AdminRowActionMenu from './ui/AdminRowActionMenu';
import {
  formatUserDisplayName,
  formatUserMetaLine,
  getUserRoleLabel
} from './userListUtils';

function getInitials(user) {
  const last = (user?.last_name || '').trim();
  const first = (user?.first_name || '').trim();
  if (last && first) return `${last[0]}${first[0]}`.toUpperCase();
  if (last) return last.slice(0, 2).toUpperCase();
  if (first) return first.slice(0, 2).toUpperCase();
  if (user?.username) return user.username.slice(0, 2).toUpperCase();
  return 'U';
}

export default function UserRowActionMenu({
  anchorEl,
  user,
  onClose,
  onView,
  onEdit,
  onToggleStatus,
  onDelete,
  disabled = false
}) {
  if (!user || !anchorEl) return null;

  const displayName = formatUserDisplayName(user);
  const metaLine = formatUserMetaLine(user);

  return (
    <AdminRowActionMenu
      anchorEl={anchorEl}
      onClose={onClose}
      title={displayName}
      subtitle={metaLine || getUserRoleLabel(user.role)}
      initials={getInitials(user)}
      badges={[
        {
          label: user.is_active ? 'Actif' : 'Inactif',
          variant: user.is_active ? 'active' : 'inactive'
        }
      ]}
      disabled={disabled}
      items={[
        {
          id: 'view',
          label: 'Voir la fiche',
          hint: 'Détails du compte',
          icon: 'eye',
          tone: 'primary',
          onClick: () => {
            onClose();
            onView(user);
          }
        },
        {
          id: 'edit',
          label: 'Modifier',
          hint: 'Éditer le profil',
          icon: 'edit',
          tone: 'primary',
          onClick: () => {
            onClose();
            onEdit(user);
          }
        },
        {
          id: 'toggle',
          label: user.is_active ? 'Désactiver' : 'Activer',
          hint: user.is_active ? 'Suspendre l\'accès' : 'Rétablir l\'accès',
          icon: user.is_active ? 'pause' : 'play',
          tone: 'warn',
          onClick: () => {
            onToggleStatus(user.id, !user.is_active);
            onClose();
          }
        }
      ]}
      footer={
        <button
          type="button"
          role="menuitem"
          className="adm-row-menu__item adm-row-menu__item--danger"
          disabled={disabled}
          onClick={() => {
            onDelete(user.id);
            onClose();
          }}
        >
          <span className="adm-row-menu__icon adm-row-menu__icon--danger" aria-hidden>
            <Icon name="trash" size={15} />
          </span>
          <span className="adm-row-menu__item-text">
            <span className="adm-row-menu__item-label">Supprimer le compte</span>
            <span className="adm-row-menu__item-hint">Action irréversible</span>
          </span>
        </button>
      }
    />
  );
}
